export default "__VITE_ASSET__BhUVc2s5__"